module.exports = __webpack_public_path__ + "img/hero3.09b139ce.png";